/* eslint-disable complexity */
import React, { useCallback } from 'react';
import { RangePicker } from 'src/@vymo/ui/blocks/dateTime';
import { differenceInMilliseconds, getTime } from 'date-fns';
// eslint-disable-next-line vymo-ui/restrict-import
import { DATE_FORMATS } from 'src/models/clientConfig/constants';
// eslint-disable-next-line vymo-ui/restrict-import
import { parseDateFormatToDateFns } from 'src/models/clientConfig/queries';
import { FormContextProps } from '../formProvider/types';

type Props = {
  value?: { date: string; duration: number; start: number; end: number };
  onChange: (arg0, arg1, arg2?) => void;
  duration: Array<number>;
  i18nConfig: any;
  viewMode?: boolean;
};

function DateTimeRangePickerAdapter({
  value,
  onChange,
  loading,
  i18nConfig,
  duration = [],
  viewMode = false,
  version,
  ...field
}: Props &
  FormContextProps & { version: FormContextProps['config']['version'] }) {
  const format = parseDateFormatToDateFns(
    i18nConfig?.client_date_time_config?.[
      DATE_FORMATS.MEETING_DATE_NOT_IN_CURRENT_YEAR
    ]?.dateTimeFormat,
  );

  const durationOffsets =
    duration.length > 0 ? [...duration].sort((a, b) => a - b) : [];

  const { duration: durationForEndDate, date, start, end } = value ?? {};

  let startDate: Date | null = null;

  let endDate: Date | null = null;

  if (version === 'webRevyre') {
    startDate = start ? new Date(start) : null;
    endDate = end ? new Date(end) : null;
  } else {
    startDate = date ? new Date(date) : null;
    endDate =
      durationForEndDate && startDate
        ? new Date(getTime(startDate) + durationForEndDate)
        : null;
  }

  const onDateTimeRangePickerChange = useCallback(
    (selectedDate, event) => {
      const [startDateValue, endDateValue] = selectedDate ?? [];
      let changeData = {};
      if (version === 'webRevyre') {
        changeData = {
          start: startDateValue ? new Date(startDateValue).getTime() : null,
          end: endDateValue ? new Date(endDateValue).getTime() : null,
        };
      } else {
        changeData = {
          date: startDateValue,
          duration: endDateValue
            ? differenceInMilliseconds(endDateValue, startDateValue)
            : null,
        };
      }

      if (field.isDebug) {
        // eslint-disable-next-line no-console
        console.log({
          'Selected Value': selectedDate,
          'On Change Value': changeData,
        });
      }
      onChange(changeData, event);
    },
    [version, field.isDebug, onChange],
  );

  return (
    <RangePicker
      value={[startDate, endDate]}
      onChange={onDateTimeRangePickerChange}
      format={format}
      duration={durationOffsets}
      showTime
      viewMode={viewMode}
      {...field}
    />
  );
}

export default DateTimeRangePickerAdapter;
